module.exports = __webpack_public_path__ + "static/media/blog1.35a8efa7.jpg";